import { useState } from "react";
import { NavLink } from "react-router-dom";

const NavItem = ({ children, to = "/", icon = "bi-shop", iconSec = "bi-shop", avatarUrl = null }) => {
    const current = window.location.pathname === to;
    const [imgFailed, setImgFailed] = useState(false);
    const showAvatar = avatarUrl && !imgFailed;

    return (
        <div>
            <NavLink to={to} className="flex [&.active]:text-red-600 font-medium text-[13px] flex-col items-center items-bar">
                {showAvatar ? (
                    <img
                        src={avatarUrl}
                        alt=""
                        onError={() => setImgFailed(true)}
                        className={`w-6 h-6 rounded-full object-cover border ${current ? "border-red-600" : "border-gray-200"}`}
                    />
                ) : (
                    <i className={`fi ${current ? iconSec : icon} text-xl`}></i>
                )}
                {children}
            </NavLink>
        </div>
    );
};

export default NavItem;
